import { ITransactionPosition } from '../interfaces/ITransactionPosition';

export function collectPrintableTicketNumbers(positions: ITransactionPosition[]): number[] {
  return positions
    .filter(position => position.type === 'cancel_ticket' && position.ticketNr != null)
    .map(position => position.ticketNr!);
}
